import branding from '../../../mixins/branding';
import VehicleCardLocalisations from '../../../lang/VehicleCard';
require('./scss/contactless-summary.scss');

export default {
    name: 'contactless-summary',

    mixins: [branding],

    i18n: VehicleCardLocalisations,

    template: `
        <div class="card-item contactless-wrapper">
            <div class="contactless-top-block">
                <div class="text-center">
                    <img class="contactless-image" :src="brandingImagesPath('/images/go-contactless.svg')" alt=""/>
                </div>
            </div>
            <div class="contactless-bottom-block">
                <div class="keyless-benefits">
                    <ul>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/arrow.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.straight_to_car') }}
                        </li>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/user.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.no_queues') }}
                        </li>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/car.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.self_checkout') }}
                        </li>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/key.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.cant_lose_the_key') }}
                        </li>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/id.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.online_id_check') }}
                        </li>
                        <li>
                            <div class="drivego-icons-wrapper">
                                <img :src="brandingImagesPath('/images/drivego-icons/phone.svg')" alt=""/>
                            </div>
                            {{ $t('VehicleCard.keyless_benefits.list.phone_as_a_key') }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `,
}
